import { cartActions } from '@shared/global-actions/actions/cart'
import { carouselActions } from '@shared/global-actions/actions/embla-api'
import set from 'lodash.set'

export const globalActions = {
  cart: cartActions,
  emblaCarousel: carouselActions,
}

export const registerActions = (actions: object, path: string[] = []) => {
  for (const [key, value] of Object.entries(actions)) {
    const currentPath = [...path, key]
    const isObject = typeof value === 'object' && value !== null

    if (isObject) {
      registerActions(value, currentPath)
    }

    if (!isObject) {
      set(window, currentPath, value)
    }
  }
}

export const registerGlobalActions = () =>
  registerActions(globalActions, ['fondof'])
